<template>
  <div class="search-index">
    <el-input :placeholder="placeholder" v-model="keyword" @focus="search" @blur="blur" clearable></el-input>
    <div class="search-index-drop" v-show="visible">
      <div class="search-index-drop-item" v-for="(row, index) in list" :key="index" @click.stop="select(row)">{{ row }}</div>
    </div>
  </div>
</template>
<script>
import * as homeApi from '@/api/home'
import { i18n } from '@/i18n'
export default {
  name: 'searchIndex',
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: i18n.$t('请输入内容')
    },
    type: {
      type: String,
      default: 'Person'
    }
  },
  computed: {
    keyword: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$nextTick(() => {
          this.search()
        })
      }
    }
  },
  data () {
    return {
      // keyword: '',
      list: [],
      visible: false,
      selectFlag: false
    }
  },
  methods: {
    select (row) {
      this.selectFlag = true
      this.keyword = row
      this.visible = false
    },
    blur () {
      this.$nextTick(() => {
        setTimeout(() => {
          this.visible = false
        }, 300)
      })
    },
    search () {
      if (this.selectFlag) {
        this.selectFlag = false
        return false
      }
      homeApi.personSearch({
        type: this.type,
        name: this.keyword
      }).then(res => {
        this.list = res.data
        if (this.list.length) {
          this.visible = true
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.search-index {
  width: 100%;
  height: 100%;
  position: relative;
  ::v-deep .el-input__suffix  {
    display: flex;
    align-items: center;
    .el-input__suffix-inner,
    i {
      display: flex;
      align-items: center;
      font-size: 24px;
    }
  }
  .search-index-drop {
    position: absolute;
    left: 0;
    top: calc(100% + 5px);
    z-index: 1000;
    width: 100%;
    border-radius: 6px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    background-color: #fff;
    max-height: 300px;
    overflow: hidden;
    overflow-y: auto;
    &-item {
      padding: 5px 10px;
      box-sizing: border-box;
      cursor: pointer;
      font-size: 16px;
      line-height: 48px;
      color: #333333;
      &:hover {
        background-color: #f8efe4;
      }
    }
  }
}
</style>
